import { render, staticRenderFns } from "./OrderNotifier.vue?vue&type=template&id=075c1fc0&scoped=true"
import script from "./OrderNotifier.vue?vue&type=script&lang=js"
export * from "./OrderNotifier.vue?vue&type=script&lang=js"
import style0 from "./OrderNotifier.vue?vue&type=style&index=0&id=075c1fc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075c1fc0",
  null
  
)

export default component.exports